<template>
  <div class="home">
    <!-- <NavbarComponent /> -->
    <!-- <NavbarDynamicComponent /> -->
    <!-- <NavbarC /> -->
    <HeroSection />
    <!-- <CounterC /> -->
    <ParterC />
    <BeritaTerkini />
    <!-- <PengumumanComponent /> -->
    <PengumumanC />


    <GalleryC />
    <!-- <VisitorC /> -->
    <!-- <Crew2C /> -->
    <FrequentC />
    <StatisticC />
    <br />
  </div>
</template>

<script>
// @ is an alias to /src
// import NavbarComponent from '@/components/NavbarComponent.vue';
// import NavbarDynamicComponent from '@/components/NavbarDynamicComponent.vue';
// import NavbarC from '@/components/NavbarC.vue';
import HeroSection from '@/components/HeroSection.vue';
import BeritaTerkini from '@/components/BeritaTerkini.vue';
// import PengumumanComponent from '@/components/PengumumanComponent.vue';
import PengumumanC from '@/components/PengumumanC.vue';

// import Crew2C from '@/components/Crew2C.vue';
import GalleryC from '@/components/widgets/GalleryC.vue';
import ParterC from '@/components/widgets/ParterC.vue';
// import VisitorC from '@/components/widgets/VisitorC.vue';
// import CounterC from '@/components/widgets/CounterC.vue';
import StatisticC from '@/components/widgets/StatisticC.vue';
import FrequentC from '@/components/widgets/FrequentC.vue';


export default {
  name: 'HomeView',
  components: {
    // NavbarComponent,
    // NavbarDynamicComponent,
    // NavbarC,
    HeroSection,
    BeritaTerkini,
    // PengumumanComponent,
    PengumumanC,

    // CounterC,
    GalleryC,
    ParterC,
    StatisticC,
    FrequentC,
    // VisitorC,
    // Crew2C,
  },

};
</script>
